import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import PartnerTableFilters from "components/subComponents/PartnerTableFilters";

import usePartnerList from "hooks/list/usePartnerList";

function ElencoPartner() {
    const partnerListHook = usePartnerList();

    const { navigateToNewPartner, alertConfirmHook, dataTableHook } = partnerListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <PartnerTableFilters partnerListHook={partnerListHook} />

                <DataTableSimple dataTableHook={dataTableHook} dontUsePaper />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewPartner}>
                        Nuovo Partners
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoPartner;
